import React, { useEffect } from "react";
import { useFetchSeasons } from "../features/season/seasonApi";
import "./Home.scss";
import bgHome from "../images/home/background-s12-home.png";
import homepageLogo from "../images/DCGP_12_Logo.png";
import { SeasonModel } from "../features/season/seasonTypes";
import {useLoading} from "../context/LoadingContext";

const Home = () => {
    const { data: seasons, isLoading } = useFetchSeasons();
    const { setLoading } = useLoading();

    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading, setLoading]);

    if (isLoading) return <div>Ładowanie...</div>;
    if (!seasons?.data) return <div>Brak danych o sezonach</div>;

    const currentSeason = seasons.data.find((season: SeasonModel) => season.current);

    if (!currentSeason) return <div>Brak aktywnego sezonu</div>;

    return (
        <div className="app-home-home">
            <div className="bg-big fade-in" style={{ backgroundImage: `url(${bgHome})` }}></div>
            <div className="home-poster">
                <div className="content-wrapper">
                    <img
                        className="dcgp-logo-main"
                        src={homepageLogo}
                        alt="DCGP Logo"
                    />
                    <a href={`/event/${currentSeason.id}`} className="show-link">
                        <img className="icon" src="/img/icons/join.png" alt="" />
                        <span>SHOW</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Home;
